// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jb3g3KXrCchs7bxYAnfb {
  height: 50px;
  width: 100%;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
  box-sizing: border-box;
  border-radius: 5px;
  color: #AEADBE;
  padding-left: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  font-family: 'Roboto', sans-serif;
}

.jb3g3KXrCchs7bxYAnfb.mf9C6wTzUeJ6yJmq5eSQ {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
}

.RlBZV67UQLADsIfyAZ1Z {
  width: 100%;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
  box-sizing: border-box;
  border-radius: 5px;
  color: #AEADBE;
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
}

.jb3g3KXrCchs7bxYAnfb .i4nbv2RvThIigphVXcAR {
  display: none;
}

.jb3g3KXrCchs7bxYAnfb input {
  border: none;
  height: 40px;
  width: 98%;
  box-sizing: border-box;
  outline: none;
  background: none;
  color: black;
  font-family: 'Roboto', sans-serif;
}

.RlBZV67UQLADsIfyAZ1Z textarea {
  border: none;
  height: 250px;
  width: 98%;
  margin: auto;
  box-sizing: border-box;
  outline: none;
  background: none;
  color: black;
  resize: none;
}

.jb3g3KXrCchs7bxYAnfb:focus-within, .iN5uEvoNNwaWSWQEOX_u, .jb3g3KXrCchs7bxYAnfb:hover {
  border-color: #526AF2;
  outline: none;
  transition: .3s;
  cursor: pointer;
}

.jb3g3KXrCchs7bxYAnfb:focus-within {
  box-shadow: 0px 0px 6px #b1bdff;
}

.wH9Qy0PhXgNwSw0VwH4c {
  margin-bottom: 8px;
  text-align: left;
}

.nz18ZYZCTZMX8F0vFR7A {
  font-size: 12px;
  margin-top: 4px;
}

@media screen and (max-width: 450px) {
  .jb3g3KXrCchs7bxYAnfb {
    height: unset;
    min-height: 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/shared/Input.module.css"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,WAAW;EACX,8DAAkC;EAClC,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,0DAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,8DAAkC;EAClC,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":["@value colors: \"../../style/colors.css\";\r\n@value purple-lighten-5, base-dark-grey, base-purple, color-purple, color-error, color-gray-light from colors;\r\n\r\n.input {\r\n  height: 50px;\r\n  width: 100%;\r\n  border: 1px solid color-gray-light;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n  color: #AEADBE;\r\n  padding-left: 8px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: white;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.input.error {\r\n  border-color: color-error;\r\n}\r\n\r\n.textarea {\r\n  width: 100%;\r\n  border: 1px solid color-gray-light;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n  color: #AEADBE;\r\n  padding: 8px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: white;\r\n}\r\n\r\n.input .ant-tooltip {\r\n  display: none;\r\n}\r\n\r\n.input input {\r\n  border: none;\r\n  height: 40px;\r\n  width: 98%;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  background: none;\r\n  color: black;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.textarea textarea {\r\n  border: none;\r\n  height: 250px;\r\n  width: 98%;\r\n  margin: auto;\r\n  box-sizing: border-box;\r\n  outline: none;\r\n  background: none;\r\n  color: black;\r\n  resize: none;\r\n}\r\n\r\n.input:focus-within, .inputActive, .input:hover {\r\n  border-color: #526AF2;\r\n  outline: none;\r\n  transition: .3s;\r\n  cursor: pointer;\r\n}\r\n\r\n.input:focus-within {\r\n  box-shadow: 0px 0px 6px #b1bdff;\r\n}\r\n\r\n.label {\r\n  margin-bottom: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.hint {\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n  .input {\r\n    height: unset;\r\n    min-height: 42px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"purple-lighten-5": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["purple-lighten-5"]}`,
	"base-dark-grey": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["base-dark-grey"]}`,
	"base-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["base-purple"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"input": `jb3g3KXrCchs7bxYAnfb`,
	"error": `mf9C6wTzUeJ6yJmq5eSQ`,
	"textarea": `RlBZV67UQLADsIfyAZ1Z`,
	"ant-tooltip": `i4nbv2RvThIigphVXcAR`,
	"inputActive": `iN5uEvoNNwaWSWQEOX_u`,
	"label": `wH9Qy0PhXgNwSw0VwH4c`,
	"hint": `nz18ZYZCTZMX8F0vFR7A`
};
export default ___CSS_LOADER_EXPORT___;
